import Link from 'next/link';
import Logo from './Logo';
import NavLink from './NavLink';
import MobileMenu from './MobileMenu';
import { getDictionary, localePath, languageNames, Locale, locales } from '@/lib/i18n';

export default function Nav({ locale }: { locale: Locale }) {
  const t = getDictionary(locale);

  const links = (
    <>
      <NavLink href={localePath(locale, '/about')}>{t.nav.about}</NavLink>
      <NavLink href={localePath(locale, '/projects')}>{t.nav.projects}</NavLink>
      <NavLink href={localePath(locale, '/contact')}>{t.nav.contact}</NavLink>
      {locales
        .filter((l) => l !== locale)
        .map((l) => (
          <NavLink key={l} href={localePath(l, '/')}>
            {languageNames[l]}
          </NavLink>
        ))}
    </>
  );

  return (
    <nav className='relative z-40 h-[80px] pr-[110px] pl-[30px]'>
      <div className='mx-auto flex h-full max-w-[1400px] items-center gap-[30px]'>
        <Link href={localePath(locale, '/')} className='block h-[32px] shrink-0' aria-label={t.nav.home}>
          <Logo />
        </Link>
        <div className='hidden flex-1 border-t-[1.5px] border-fg md:block' />
        <div className='hidden items-center gap-[24px] text-sm uppercase tracking-wide md:flex'>
          {links}
        </div>
        <MobileMenu>{links}</MobileMenu>
      </div>
    </nav>
  );
}
